import { CircleCheck, CircleOff, ListFilter, Search, UserPlus } from 'lucide-react';
import type { DashboardStatusFilter } from '../../../types/admin-dashboard';

type Props = {
  search: string;
  status: DashboardStatusFilter;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: DashboardStatusFilter) => void;
  onNewAccount: () => void;
};

const statuses: Array<{ value: DashboardStatusFilter; label: string; className: string }> = [
  { value: 'ACTIVE', label: 'Active', className: 'crystal-emerald text-[#DCEAE5]' },
  { value: 'INACTIVE', label: 'Inactive', className: 'crystal-ruby text-[#EADDE0]' },
  { value: 'ALL', label: 'All', className: 'crystal-smoky text-[#D6DEE8]' },
];

export default function AdminDashboardFilters({ search, status, onSearchChange, onStatusChange, onNewAccount }: Props) {
  return (
    <div className="space-y-2.5">
      <section className="rounded-2xl border border-white/10 bg-[rgba(18,26,43,0.85)] p-2.5 shadow-[0_12px_28px_rgba(0,0,0,0.24)] backdrop-blur-md">
        <div className="grid grid-cols-3 gap-2">
          {statuses.map((option) => {
            const selected = status === option.value;
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => onStatusChange(option.value)}
                className={`crystal-btn relative h-9 min-w-0 overflow-hidden whitespace-nowrap rounded-xl px-2 text-[11px] font-black tracking-[-0.01em] [-webkit-tap-highlight-color:transparent] sm:text-xs ${option.className} ${selected ? 'brightness-105 ring-1 ring-white/10' : 'opacity-94'}`}
              >
                <span className="inline-flex items-center justify-center gap-1.5">{option.value === 'ACTIVE' ? <CircleCheck size={13} /> : option.value === 'INACTIVE' ? <CircleOff size={13} /> : <ListFilter size={13} />}{option.label}</span>
              </button>
            );
          })}
        </div>
      </section>

      <section className="rounded-2xl border border-white/10 bg-[rgba(18,26,43,0.72)] p-2.5 shadow-[0_10px_22px_rgba(0,0,0,0.22)] backdrop-blur-md">
        <div className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2">
          <label className="min-w-0">
            <span className="sr-only">Search User</span>
            <div className="crystal-search flex h-10 items-center rounded-xl px-3">
              <Search size={15} className="mr-2 shrink-0 text-slate-400" aria-hidden="true" />
              <input
                type="search"
                value={search}
                onChange={(event) => onSearchChange(event.target.value)}
                placeholder="Search"
                autoComplete="off"
                className="admin-data-primary dashboard-search-input min-w-0 flex-1 appearance-none border-0 bg-transparent text-sm font-semibold caret-sky-300 outline-none ring-0 shadow-none placeholder:text-slate-500 focus:border-0 focus:outline-none focus:ring-0 focus:shadow-none focus-visible:border-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none [-webkit-appearance:none] [&::-webkit-search-cancel-button]:hidden [&::-webkit-search-decoration]:hidden"
              />
            </div>
          </label>
          <button type="button" onClick={onNewAccount} className="crystal-btn crystal-sapphire inline-flex h-10 items-center justify-center gap-1.5 rounded-xl px-3 text-[11px] font-black whitespace-nowrap text-[#DCEAF2] sm:px-4 sm:text-xs"><UserPlus size={15} aria-hidden="true" />New Account</button>
        </div>
      </section>
    </div>
  );
}
